import { useSelector } from 'react-redux';
import { getLMSGroups } from '../../reducers/getLMSInfo';
import { hasCourseRole } from '../../utilites/hasCourseRole';
import useCommonProps from '../useCommonProps';
import { useMemo } from 'react';
import { bProfile, useProfile } from '@brg/auth';
export var useGetHasGroupAccess = function (groupIds, isAnyBlock) {
    var role = useCommonProps().role;
    var profile = useProfile();
    var _a = useSelector(function (store) {
        return getLMSGroups(store);
    }), isLoaded = _a.isLoaded, isLoading = _a.isLoading, groups = _a.groups;
    var isModer = useMemo(function () { return (profile && bProfile.isModer(profile)); }, [profile]);
    var isNone = hasCourseRole('none', role);
    var isStudent = hasCourseRole('student', role);
    var isTeacher = hasCourseRole('teacher', role);
    var availableGroupIds = useMemo(function () {
        var _a, _b;
        if (isStudent)
            return (_a = groups === null || groups === void 0 ? void 0 : groups.filter(function (group) { var _a; return (_a = group === null || group === void 0 ? void 0 : group.membersIDs) === null || _a === void 0 ? void 0 : _a.includes(profile === null || profile === void 0 ? void 0 : profile.accountId); })) === null || _a === void 0 ? void 0 : _a.map(function (group) { return group === null || group === void 0 ? void 0 : group.id; });
        return (_b = groups === null || groups === void 0 ? void 0 : groups.filter(function (group) { var _a; return (_a = group === null || group === void 0 ? void 0 : group.teachersIDs) === null || _a === void 0 ? void 0 : _a.includes(profile === null || profile === void 0 ? void 0 : profile.accountId); })) === null || _b === void 0 ? void 0 : _b.map(function (group) { return group === null || group === void 0 ? void 0 : group.id; });
    }, [isStudent, isTeacher, profile, groups]);
    if (isModer)
        return true;
    if ((!isLoaded || isLoading || isNone) &&
        (!isAnyBlock || (groupIds === null || groupIds === void 0 ? void 0 : groupIds.length) > 0))
        return false;
    return Boolean((groupIds === null || groupIds === void 0 ? void 0 : groupIds.some(function (groupId) { return availableGroupIds === null || availableGroupIds === void 0 ? void 0 : availableGroupIds.includes(groupId); })) ||
        (groupIds === null || groupIds === void 0 ? void 0 : groupIds.length) === 0);
};
//# sourceMappingURL=hasGroupAccess.js.mapimport { useSelector } from 'react-redux';
import { getLMSGroups } from '../../reducers/getLMSInfo';
import { hasCourseRole } from '../../utilites/hasCourseRole';
import useCommonProps from '../useCommonProps';
import { useMemo } from 'react';
import { bProfile, useProfile } from '@brg/auth';
export var useGetHasGroupAccess = function (groupIds, isAnyBlock) {
    var role = useCommonProps().role;
    var profile = useProfile();
    var _a = useSelector(function (store) {
        return getLMSGroups(store);
    }), isLoaded = _a.isLoaded, isLoading = _a.isLoading, groups = _a.groups;
    var isModer = useMemo(function () { return (profile && bProfile.isModer(profile)); }, [profile]);
    var isNone = hasCourseRole('none', role);
    var isStudent = hasCourseRole('student', role);
    var isTeacher = hasCourseRole('teacher', role);
    var availableGroupIds = useMemo(function () {
        var _a, _b;
        if (isStudent)
            return (_a = groups === null || groups === void 0 ? void 0 : groups.filter(function (group) { var _a; return (_a = group === null || group === void 0 ? void 0 : group.membersIDs) === null || _a === void 0 ? void 0 : _a.includes(profile === null || profile === void 0 ? void 0 : profile.accountId); })) === null || _a === void 0 ? void 0 : _a.map(function (group) { return group === null || group === void 0 ? void 0 : group.id; });
        return (_b = groups === null || groups === void 0 ? void 0 : groups.filter(function (group) { var _a; return (_a = group === null || group === void 0 ? void 0 : group.teachersIDs) === null || _a === void 0 ? void 0 : _a.includes(profile === null || profile === void 0 ? void 0 : profile.accountId); })) === null || _b === void 0 ? void 0 : _b.map(function (group) { return group === null || group === void 0 ? void 0 : group.id; });
    }, [isStudent, isTeacher, profile, groups]);
    if (isModer)
        return true;
    if ((!isLoaded || isLoading || isNone) &&
        (!isAnyBlock || (groupIds === null || groupIds === void 0 ? void 0 : groupIds.length) > 0))
        return false;
    return Boolean((groupIds === null || groupIds === void 0 ? void 0 : groupIds.some(function (groupId) { return availableGroupIds === null || availableGroupIds === void 0 ? void 0 : availableGroupIds.includes(groupId); })) ||
        (groupIds === null || groupIds === void 0 ? void 0 : groupIds.length) === 0);
};
//# sourceMappingURL=hasGroupAccess.js.map